export enum InvoiceItemReferenceType {
    EngagementEvent = 1,
    SelectedBuyer = 2,
    EngagementDocument = 3,
    MonthlyRetainerFee = 4,
    SuspensionFee = 5,
}

export const InvoiceItemReferenceTypeOptions = [
    {
        value: InvoiceItemReferenceType.EngagementEvent,
        label: 'Engagement Event',
    },
    { value: InvoiceItemReferenceType.SelectedBuyer, label: 'Selected Buyer' },
    {
        value: InvoiceItemReferenceType.EngagementDocument,
        label: 'Engagement Document',
    },
    {
        value: InvoiceItemReferenceType.MonthlyRetainerFee,
        label: 'Monthly Engagement Fee',
    },
    {
        value: InvoiceItemReferenceType.SuspensionFee,
        label: 'Monthly Suspension Fee',
    },
];
